module.exports = __webpack_public_path__ + "img/pic33.2575eb84.png";